/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, Fragment, useMemo } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Checkbox, Divider, Drawer, Dropdown, Popconfirm, Table, Tag, Tooltip } from 'antd';
import { ControlOutlined, ExclamationCircleFilled, FilterOutlined, UpCircleTwoTone } from '@ant-design/icons';
import dayjs from 'dayjs';
import H3Text from '@Uilib/h3Text';
import DNActions from '@Actions/dnActions.js';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { toISTDate, entityNameEnum, filterTypeEnums } from '@Apis/constants';
import Busy from '@Images/admin/integrations/busy.png';
import TallyPrime from '@Images/admin/integrations/tally-prime.png';
import ZohoBooks from '@Images/admin/integrations/zoho-books.png';
import ZohoIntegrationActions from '@Actions/integrations/zohoIntegrationActions';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import BusyIntegrationActions from '@Actions/integrations/busyIntegrationAction';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons';
import closeIcon from '@Images/icons/icon-close-blue.png';
import PRZText from '../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import { ListScreenKeys } from './mobileListHelper';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';

function DebitNoteList({
  debitNotes, getDNLoading, user, getDN, getDNSuccess, history, syncDN, syncDNLoading, getDocCFV2Loading, customFieldsProps, getDocCFV2, getDocCFV2Success, MONEY, pushDebitNoteToBusyLoading, pushDebitNoteToBusy, syncTallyGRNLoading, syncTallyGRN
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedTenant, setSelectedTenant] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [fixedColumns, setFixedColumns] = useState(['DN_NUMBER']);
  const [call, setCall] = useState(false);
  const [selectedDN, setSelectedDN] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);
  // Saved Filter View States
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-dn') ? JSON.parse(localStorage.getItem('prcz-page-columns-dn')) : {
    DN_NUMBER: {
      label: 'Debit Note#',
      visible: true,
    },
    LOCATION: {
      label: 'Location',
      visible: true,
    },
    PO_NUMBER: {
      label: 'Purchase Order#',
      visible: true,
    },
    GRN_NUMBER: {
      label: 'GRN #',
      visible: true,
    },
    VENDOR: {
      label: 'Vendor',
      visible: true,
    },
    AMOUNT_WITHOUT_TAX: {
      label: 'Amount (Without Tax)',
      visible: false,
    },
    TAXES: {
      label: 'Taxes',
      visible: false,
    },
    AMOUNT_WITH_TAX: {
      label: 'Total Amount',
      visible: true,
    },
    CREATED_DATE: {
      label: 'Created Date',
      visible: true,
    },
    DN_DATE: {
      label: 'GRN Date',
      visible: true,
    },
    STATUS: {
      label: 'Status',
      visible: true,
    },
    ATTACHMENTS: {
      label: 'Attachments',
      visible: true,
    },
  });
  const pushParamsToUrl = (page, limit, currentTenant, word, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (limit) url += `&limit=${limit}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (word) url += `&keyword=${word}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };
  // common 
  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }
  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => [
    {
      filter_key: 'keyword',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'limit',
      filter_value: limit,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'tenant',
      filter_value: [user?.tenant_info?.tenant_id],
      filter_type: filterTypeEnums.ARRAY,
    },
  ], []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.DEBIT_NOTE,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    setSelectedFilterView(systemDefaultUserView);
    return () => {
      getDocCFV2Success(null);
    };
  }, []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');
      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);
      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        // common state
        setCurrentlyAppliedFilters(appliedFiltersFromURL);
        // temp state
        setCurrentPage(tempFilterValues.page || 1);
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedTenant(tempFilterValues.tenant);
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  // useEffect(() => {
  //   if (user?.tenant_info?.org_id) {
  //     setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
  //     setLimit(Number(Helpers.getValueFromUrl('limit') || limit));
  //     setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (Number(item))) : [user?.tenant_info?.tenant_id]);
  //     setSearchKeyword(Helpers.getValueFromUrl('keyword'));
  //     setKeyword(Helpers.getValueFromUrl('keyword'));
  //     setIsUserReady(true);
  //   }
  //   return () => {
  //     getDocCFV2Success(null);
  //   };
  // }, []);

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, selectedTenant, searchKeyword, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getDNSuccess(null);
      const payload = {
        orgId: user?.tenant_info?.org_id,
        entityName: 'DEBIT_NOTE',
      };
      getDocCFV2(payload);
      getDN(selectedTenant?.filter(
        (item) => !isNaN(item),
      )?.length > 0 ? selectedTenant?.join(',')
        : Helpers.getTenantEntityPermission(
          user?.user_tenants, Helpers.permissionEntities.DEBIT_NOTE, Helpers.permissionTypes.READ,
        )?.join(','), null, null, Helpers.getValueFromUrl('status'), Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'),
        Helpers.getValueFromUrl('keyword'), true);
    }
  }, [selectedTenant, searchKeyword, currentPage, limit, call]);

  useEffect(() => {
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customFields = customFieldsProps?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-dn'))?.[customField.cf_id]?.visible || false,
        };
      });
      setVisibleColumns(columns);
    }
  }, [customFieldsProps]);

  const getDNColumns = () => {
    const GRNListColumns = [
      // {
      //   title: '',
      //   render: (record) => (
      //     <Link to={`/purchase/debit-note/view/${record.dn_id}`}>
      //       <div className="mobile-list__item">
      //         <div style={{ display: 'flex' }}>
      //           <H3Text text={`#${record?.debit_note_number}`} className="mobile-list__item-number" />
      //           <div className="mobile-list__item-status" style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}>
      //             {Helpers.getStatusColor(record.status).text?.toUpperCase()}
      //           </div>
      //         </div>
      //         <H3Text text={`Location - ${record?.tenant_info?.tenant_name}`} className="mobile-list__item-info" />
      //         <H3Text text={`Amount - ${MONEY((record?.po_grand_total || '0'), record?.org_currency_info?.currency_code)}`} className="mobile-list__item-info" />
      //         <H3Text
      //           text={`PO# - ${record?.po_number}`}
      //           className="mobile-list__item-info"
      //         />
      //         <H3Text text={`GRN# - ${record?.grn_number}`} className="mobile-list__item-info" />
      //         <H3Text text={`Created by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer" />
      //       </div>
      //     </Link>
      //   ),
      //   responsive: ['xs'],
      // },
      {
        title: '',
        render: (record) => {
          return (
            <div className="mobile-list__card">
              <div className="mobile-list__card_header">
                <div className="mobile-list__card_header-left">
                  <PRZText className="mobile-list__card_item-number" text={`#${record?.debit_note_number ? record.debit_note_number : 'N/A'}`} />
                </div>
                <div className="mobile-list__card_header-right">
                  <PRZText
                    style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}
                    text={Helpers.getStatusColor(record.status).text?.toUpperCase()}
                    className="qr__status"
                  />
                </div>
              </div>
              <div className="mobile-list__card_body">
                <div className="mobile-list__card_body-left">
                  <div className="mobile-list__card_item-name_wrapper">
                    <Link to={`/vendors/view/${record?.seller_id}`} target="_blank">
                      <PRZText
                        className="mobile-list__card_item-name"
                        text={(record && record.tenant_seller_info) ? `${record?.internal_slr_code ? `${record?.internal_slr_code} - ` : ''}${record.tenant_seller_info?.seller_name}`?.trim() : ''}
                      />
                    </Link>
                  </div>
                  <PRZText
                    text={`Location - ${record?.tenant_info?.tenant_name} (${record?.tenant_department_info?.department_name || 'N/A'})`}
                    className="mobile-list__card_item-details"
                  />
                  <PRZText
                    text={`Debit Note Date - ${toISTDate(record?.dn_date).format('DD/MM/YYYY')}`}
                    className="mobile-list__card_item-details"
                  />
                  <PRZText
                    text={`Created Date - ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`}
                    className="mobile-list__card_item-details"
                  />
                </div>
                <div className="mobile-list__card_body-right">
                  <Tooltip
                    color="white"
                    placement="top"
                    title={(
                      <PRZText className="mobile-list__card_item__tooltip_text-color" text="Amount" />
                    )}
                  >
                    <PRZText
                      text={MONEY((record.dn_grand_total || '0'), record?.org_currency_info?.currency_code)}
                    />
                  </Tooltip>
                </div>
              </div>
              <Divider className="mobile-list__card_divider" />
              <div className="mobile-list__card_footer">
                <div className="mobile-list__card_footer-left">
                  <div className="mobile-list__card_footer__actions-button_wrapper">
                    {user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_info?.tenant_id)?.zoho_branch_id && (
                      <div className="card_footer__actions-button">
                        <Fragment>
                          {
                            ['GOOD_RECEIVING_NOTE', 'PURCHASE_ORDER'].includes(record.grn_entity_type) && record?.status === 'CONFIRMED' && user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_info?.tenant_id)?.zoho_branch_id && (
                              <div>
                                {(record?.zoho_vendor_credit_id)
                                  ? (
                                    <Tooltip
                                      title={toISTDate(record?.zoho_updated_at).format('DD/MM/YYYY hh:mm A')}
                                      overlayClassName="font-12"
                                      placement="topRight"
                                    >
                                      <a
                                        href={`https://books.zoho.in/app#/vendorcredits/${record?.zoho_vendor_credit_id}`}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        <div className="card_footer__actions-button_image__wrapper img-zoho__wrapper">
                                          <img
                                            style={{
                                              width: '18px',
                                              height: '18px',
                                            }}
                                            src={ZohoBooks}
                                            alt="Zoho"
                                            className="img-zoho card_footer__actions-button_image"
                                          />
                                          <div className="green-indicator" />
                                        </div>
                                      </a>
                                    </Tooltip>
                                  )
                                  : (
                                    <Popconfirm
                                      title={(record?.zoho_warning_message === null || record?.zoho_warning_message === '') ? 'This DN is not synced with Zoho Books.' : `${record?.zoho_warning_message}`}
                                      onConfirm={() => {
                                        if (!syncDNLoading) {
                                          syncDN(
                                            { dn_id: record?.dn_id },
                                            () => getDN(user?.tenant_info?.tenant_id, null, null, null, currentPage, limit, searchKeyword, true),
                                          );
                                        }
                                      }}
                                      okText="Sync again"
                                      okButtonProps={{
                                        loading: syncDNLoading,
                                      }}
                                      cancelText="Cancel"
                                    >
                                      <div className="img-zoho__wrapper card_footer__actions-button_image__wrapper">
                                        <img
                                          style={{
                                            width: '18px',
                                            height: '18px',
                                          }}
                                          src={ZohoBooks}
                                          alt="Zoho"
                                          className="img-zoho img-zoho__disabled card_footer__actions-button_image"
                                        />
                                        <div className="green-indicator red-indicator" />
                                      </div>
                                    </Popconfirm>
                                  )}
                              </div>
                            )
                          }
                        </Fragment>
                      </div>
                    )}

                    {
                      (record?.debit_note_voucher_integration && (['CONFIRMED', 'VOID'].includes(record?.status))) &&
                      (record?.tally_updated_at
                        ? (
                          <Tooltip
                            title={`Last updated at ${toISTDate(record?.tally_updated_at).format('DD/MM/YYYY hh:mm A')}`}
                            overlayClassName="font-12"
                            placement="topRight"
                          >
                            <div className="card_footer__actions-button">
                              <div className="img-tally__wrapper card_footer__actions-button_image__wrapper">
                                <img
                                  style={{
                                    width: '16px',
                                    height: '16px',
                                  }}
                                  src={TallyPrime}
                                  alt="Tally"
                                  className="img-tally card_footer__actions-button_image"
                                />
                                <div className="green-indicator" />
                              </div>
                            </div>
                          </Tooltip>
                        )
                        : (
                          <Popconfirm
                            title={record?.tally_warning_message || 'This DN is not synced with Tally.'}
                            onConfirm={() => syncTallyGRN(
                              { dn_id: record?.dn_id },
                              () => getDN(user?.tenant_info?.tenant_id, null, null, null, currentPage, limit, searchKeyword, true),
                            )}
                            okText="Sync again"
                            okButtonProps={{
                              loading: syncTallyGRNLoading,
                            }}
                            cancelText="Cancel"
                          >
                            <div className="card_footer__actions-button">
                              <div className="img-tally__wrapper card_footer__actions-button_image__wrapper">
                                <img
                                  style={{
                                    width: '16px',
                                    height: '16px',
                                  }}
                                  src={TallyPrime}
                                  alt="Tally"
                                  className="img-tally img-tally__disabled card_footer__actions-button_image"
                                />
                                <div className="green-indicator red-indicator" />
                              </div>
                            </div>
                          </Popconfirm>
                        ))
                    }

                    {['CONFIRMED'].includes(record.status) && record?.busy_location_name && (
                      <Popconfirm
                        title={(record?.busy_sync_error ? record?.busy_sync_error : (record?.busy_voucher_id ? 'Debit Note is already synced with Busy' : 'Debit Note is not synced with Busy'))}
                        onConfirm={() => pushDebitNoteToBusy(
                          { dn_id: record?.dn_id },
                          () => setCall(!call),
                        )}
                        okText={(!record?.busy_sync_error && !record?.busy_voucher_id) ? 'Sync' : 'Sync Again'}
                        okButtonProps={{
                          loading: pushDebitNoteToBusyLoading,
                        }}
                        cancelText="Cancel"
                        icon={record?.busy_sync_error ? <ExclamationCircleFilled style={{ color: '#F2BD27' }} /> : <React.Fragment />}
                      >
                        <div className="card_footer__actions-button">
                          <div className="img-tally__wrapper card_footer__actions-button_image__wrapper">
                            <img
                              src={Busy}
                              alt="busy"
                              className="img-tally card_footer__actions-button_image"
                            />
                            {(!record?.busy_sync_at || record?.busy_sync_error) && <div className={`tally-corner-icon actions-button__corner-icon ${record?.busy_sync_error && 'red-indicator'}`}>{!record?.busy_sync_error && <UpCircleTwoTone twoToneColor="#52c41a" />}</div>}
                          </div>
                        </div>
                      </Popconfirm>
                    )}
                  </div>
                </div>
                <div className="mobile-list__card_footer-right">
                  <PRZText
                    className="mobile-list__card__view-more_wrapper"
                    onClick={() => {
                      setSelectedDN(record);
                      setMoreDetailsDrawer(true);
                    }}
                    text={(
                      <span className="mobile-list__card__view-more-text_wrapper">
                        <span className="mobile-list__card__view-more-text">More Info</span>
                        <FontAwesomeIcon
                          className="mobile-list__card__view-more-icon"
                          icon={faAnglesRight}
                        />
                      </span>
                    )}
                  />
                </div>
              </div>
            </div>
          );
        },
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'DN #',
        render: (record) => (
          <div className="min-width-50">
            {record?.debit_note_number}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.DN_NUMBER.visible ? 'display-none' : '',
        fixed: 'left',
      },
      {
        title: 'LOCATION',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.tenant_info?.tenant_name} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.LOCATION.visible ? 'display-none' : '',
      },
      {
        title: 'PO#',
        render: (text, record) => (
          <div className="associated-entity min-width-50">
            {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER,
              Helpers.permissionTypes.READ, user)
              ? (record?.po_number ? (
                <Link to={`/approval?type=po&id=${record?.po_id}`} target="_blank">
                  {record?.po_number}
                </Link>
              ) : '-') : (record?.po_id || '')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.PO_NUMBER.visible ? 'display-none' : '',
      },
      {
        title: 'GRN#',
        render: (text, record) => (
          <div className="associated-entity min-width-50">
            {Helpers.getPermission(Helpers.permissionEntities.GOOD_RECEIVING,
              Helpers.permissionTypes.READ, user)
              ? (record?.grn_number ? (
                <Link to={`/purchase/goods-receiving/view/${record?.grn_id}`} target="_blank">
                  {record?.grn_number}
                </Link>
              ) : '-') : ''}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.GRN_NUMBER.visible ? 'display-none' : '',
      },
      {
        title: 'VENDOR',
        render: (record) => (
          <div className="associated-entity min-width-70">
            {Helpers.getPermission(Helpers.permissionEntities.VENDORS, Helpers.permissionTypes.READ, user) ? ((record?.tenant_seller_info?.tenant_seller_id || record?.tenant_seller_id) ? (
              <Link to={`/vendors/view/${record?.seller_id}`} target="_blank">
                {`${record?.internal_slr_code} - ${record?.tenant_seller_info?.seller_name}`}
              </Link>
            ) : '-')
              : (
                <React.Fragment>
                  <div className="dn__internal-slr-code">
                    {record?.internal_slr_code || '-'}
                  </div>
                  <H3Text text={record?.tenant_seller_info?.seller_name} className="" />
                </React.Fragment>
              )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.VENDOR.visible ? 'display-none' : '',
      },
      {
        title: 'AMOUNT WITHOUT TAX',
        render: (record) => (
          <div className="column-amount min-width-150">
            {MONEY((record?.dn_base_price || '0'), record?.org_currency_info?.currency_code)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.AMOUNT_WITHOUT_TAX.visible ? 'display-none' : '',
      },
      {
        title: 'TAXES',
        render: (record) => (
          <div className="column-amount min-width-50">
            {record?.seller_type === "OVERSEAS" ? "-" : MONEY((record?.dn_taxes || '0'), record?.org_currency_info?.currency_code)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.TAXES.visible ? 'display-none' : '',
      },
      {
        title: 'AMOUNT',
        render: (record) => (
          <div className="column-amount min-width-70">
            {MONEY((record?.dn_grand_total || '0'), record?.org_currency_info?.currency_code)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.AMOUNT_WITH_TAX.visible ? 'display-none' : '',
      },
      {
        title: 'CREATION DATE',
        render: (record) => (
          <div>
            <div className="column-date min-width-100">
              {toISTDate(record?.created_at).format('DD/MM/YYYY')}
            </div>
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.CREATED_DATE.visible ? 'display-none' : '',
      },
      {
        title: 'DEBIT DATE',
        render: (record) => (
          <div className="column-date min-width-85">
            {dayjs(record?.dn_date).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.DN_DATE.visible ? 'display-none' : '',
      },
      {
        title: 'ATTACHMENTS',
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ATTACHMENTS?.visible ? 'display-none' : '',
      },
      {
        title: 'STATUS',
        render: (item) => (
          <div className="qr__status min-width-70" style={{ backgroundColor: Helpers.getStatusColor(item?.status).color }}>
            {Helpers.getStatusColor(item?.status).text}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.STATUS.visible ? 'display-none' : '',
      },
    ];
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customs = customFieldsProps?.data?.document_custom_fields;
      customs?.filter((item) => item?.is_active)?.map((custom) => {
        GRNListColumns.push({
          title: custom.field_name?.toUpperCase(),
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields customField={record.dn_custom_fields?.filter((subItem) => subItem.cf_id === custom.cf_id)?.[0]} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          className: !visibleColumns?.[custom.cf_id]?.visible ? 'display-none' : '',
        });
      });
    }
    GRNListColumns.push({
      title: '',
      render: (text, record) => (
        <div className="list__actions">
          {
            (record?.debit_note_voucher_integration && (['CONFIRMED', 'VOID'].includes(record?.status)))
            && (
              <div className="list__actions-button">
                {record?.tally_updated_at
                  ? (
                    <Tooltip
                      title={`Last updated at ${toISTDate(record?.tally_updated_at).format('DD/MM/YYYY hh:mm A')}`}
                      overlayClassName="font-12"
                      placement="topRight"
                    >
                      <div className="img-tally__wrapper">
                        <img
                          src={TallyPrime}
                          alt="Tally"
                          className="img-tally "
                        />
                        <div className="green-indicator" />
                      </div>
                    </Tooltip>
                  )
                  : (
                    <Popconfirm
                      placement="topRight"
                      title={record?.tally_warning_message || 'This DN is not synced with Tally.'}
                      onConfirm={() => syncTallyGRN(
                        { dn_id: record?.dn_id },
                        () => getDN(user?.tenant_info?.tenant_id, null, null, null, currentPage, limit, searchKeyword, true),
                      )}
                      okText="Sync again"
                      okButtonProps={{
                        loading: syncTallyGRNLoading,
                      }}
                      cancelText="Cancel"
                    >
                      <div className="img-tally__wrapper">
                        <img
                          src={TallyPrime}
                          alt="Tally"
                          className="img-tally img-tally__disabled"
                        />
                        <div className="green-indicator red-indicator" />
                      </div>
                    </Popconfirm>
                  )}
              </div>
            )
          }
          {user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_info?.tenant_id)?.zoho_branch_id && (
            <Fragment>
              {
                ['GOOD_RECEIVING_NOTE', 'PURCHASE_ORDER'].includes(record.grn_entity_type) && record?.status === 'CONFIRMED' && user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_info?.tenant_id)?.zoho_branch_id && (
                  <div className="list__actions-button">
                    {(record?.zoho_vendor_credit_id)
                      ? (
                        <Tooltip
                          title={toISTDate(record?.zoho_updated_at).format('DD/MM/YYYY hh:mm A')}
                          overlayClassName="font-12"
                          placement="topRight"
                        >
                          <a
                            href={`https://books.zoho.in/app#/vendorcredits/${record?.zoho_vendor_credit_id}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <div className="img-zoho__wrapper">
                              <img
                                src={ZohoBooks}
                                alt="Zoho"
                                className="img-zoho"
                              />
                              <div className="green-indicator" />
                            </div>
                          </a>
                        </Tooltip>
                      )
                      : (
                        <Popconfirm
                          placement="topRight"
                          title={(record?.zoho_warning_message === null || record?.zoho_warning_message === '') ? 'This DN is not synced with Zoho Books.' : `${record?.zoho_warning_message}`}
                          onConfirm={() => {
                            if (!syncDNLoading) {
                              syncDN(
                                { dn_id: record?.dn_id },
                                () => getDN(user?.tenant_info?.tenant_id, null, null, null, currentPage, limit, searchKeyword, true),
                              )
                            }

                          }}
                          okText="Sync again"
                          okButtonProps={{
                            loading: syncDNLoading,
                          }}
                          cancelText="Cancel"
                        >
                          <div className="img-zoho__wrapper">
                            <img
                              src={ZohoBooks}
                              alt="Zoho"
                              className="img-zoho img-zoho__disabled"
                            />
                            <div className="green-indicator red-indicator" />
                          </div>
                        </Popconfirm>
                      )}
                  </div>
                )
              }
            </Fragment>
          )}
          {['CONFIRMED'].includes(record.status) && record?.busy_location_name && (
            <Popconfirm
              placement="topRight"
              title={(record?.busy_sync_error ? record?.busy_sync_error : (record?.busy_voucher_id ? 'Debit Note is already synced with Busy' : 'Debit Note is not synced with Busy'))}
              onConfirm={() => pushDebitNoteToBusy(
                { dn_id: record?.dn_id },
                () => setCall(!call),
              )}
              okText={(!record?.busy_sync_error && !record?.busy_voucher_id) ? 'Sync' : 'Sync Again'}
              okButtonProps={{
                loading: pushDebitNoteToBusyLoading,
              }}
              cancelText="Cancel"
              icon={record?.busy_sync_error ? <ExclamationCircleFilled style={{ color: '#F2BD27' }} /> : <React.Fragment />}
            >
              <div className="list__actions-button img-tally__wrapper">
                <img
                  src={Busy}
                  alt="busy"
                  className="img-tally"
                />
                {(!record?.busy_sync_at || record?.busy_sync_error) && <div className={`tally-corner-icon  ${record?.busy_sync_error && 'red-indicator'}`}>{!record?.busy_sync_error && <UpCircleTwoTone twoToneColor="#52c41a" />}</div>}
              </div>
            </Popconfirm>
          )}
          {!isPortrait && (
            <div className="list__actions-button list__actions-button-dark" onClick={() => history.push(`/purchase/debit-note/view/${record.dn_id}`)}>
              View
            </div>
          )}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
      className: 'list__actions-column',
      fixed: 'right',
    });
    return GRNListColumns.filter((item) => !item.hidden);
  };

  return (
    <Fragment>
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedDN?.debit_note_number}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          customFields={selectedDN?.custom_fields}
          fields={ListScreenKeys({ documentData: selectedDN, MONEY, user })}
        />
      </Drawer>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for Debit Note..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(Helpers.permissionEntities.DEBIT_NOTE, Helpers.permissionTypes.CREATE, user) && (
                  <div className="doc-list__buttons-wrapper">
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ New Debit Note"
                      onClick={() => {
                        history.push('/purchase/debit-notes/create');
                      }}
                      customClass="add-button"
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const tempFilterValues = filterValue;
                    // common state
                    setCurrentlyAppliedFilters(currentSelectedViewFilters);
                    // temp states
                    setKeyword(tempFilterValues.keyword);
                    setSearchKeyword(tempFilterValues.keyword);
                    setLimit(tempFilterValues.limit);
                    setCurrentPage(1);
                    setSelectedTenant(tempFilterValues.tenant);
                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.DEBIT_NOTE}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search results for -
                    &nbsp;
                    <span><b><i>{searchKeyword}</i></b></span>
                  </Tag>
                )}

                {selectedTenant && selectedTenant?.map((item) => (
                  <Tag
                    key={item}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
              </div>
            </div>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${(debitNotes && debitNotes?.data?.count) ? debitNotes?.data?.count : '0'} Debit Notes Generated`} className="" />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        <Dropdown
                          trigger={['click']}
                          overlay={(
                            <div className="header__filter__container">
                              <div className="header__filter__container__title">
                                Apply Filters
                              </div>
                              <div className="filter__container filter__container-section">
                                <div className="filter__title">Business Unit</div>
                                <TenantSelector
                                  selectedTenant={selectedTenant}
                                  showSearch
                                  onChange={(value) => {
                                    setSelectedTenant(value);
                                  }}
                                  placeholder="Select Business Unit"
                                  inputClassName="orgInputContainer"
                                  isMultiple
                                  hideTitle
                                  includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.DEBIT_NOTE, Helpers.permissionTypes.READ)}
                                />
                              </div>

                            </div>
                          )}
                        >
                          <div className="action-buttons">
                            <div className="action-button">
                              <H3Text text="Filters" className="action-button-text" />
                              <FilterOutlined />
                            </div>
                          </div>
                        </Dropdown>
                        <Dropdown
                          overlay={(
                            <div className="custom-columns__content">
                              <div className="custom-columns__content-section">
                                <H3Text text="Visible Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={() => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                          localStorage.setItem('prcz-page-columns-dn', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                              {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                                <div className="custom-columns__content-section">
                                  <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                  {
                                    Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                      <div key={key}>
                                        <Checkbox
                                          disabled={fixedColumns.includes(key)}
                                          checked={visibleColumns[key]?.visible}
                                          onChange={() => {
                                            const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                            visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                            localStorage.setItem('prcz-page-columns-dn', JSON.stringify(visibleColumnsCopy));
                                            setVisibleColumns(visibleColumnsCopy);
                                          }}
                                        >
                                          {visibleColumns[key]?.label}
                                        </Checkbox>
                                      </div>
                                    ))
                                  }
                                </div>
                              ) : ''}
                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper">
                            Customize Columns
                            <ControlOutlined />
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                )}
                bordered
                loading={getDNLoading || getDocCFV2Loading || pushDebitNoteToBusyLoading || savedFilterViewsLoading}
                showHeader
                size="small"
                scroll={!isMobileOrPortrait && debitNotes && !!debitNotes?.data?.debit_notes?.length ? { x: 'max-content', y: 'calc(100dvh - 180px)' } : { x: 'max-content' }}
                // sticky={debitNotes && !!debitNotes?.data?.debit_notes?.length}
                columns={getDNColumns()}
                dataSource={debitNotes && debitNotes?.data?.debit_notes ? debitNotes?.data?.debit_notes : []}
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: debitNotes ? debitNotes?.data?.count : 0,
                    pageSize: limit,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                  }
                }
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, DNReducers, CFV2Reducers, BusyIntegrationReducers, ZohoIntegrationReducers
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getDNLoading: DNReducers.getDNLoading,
  debitNotes: DNReducers.debitNotes,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  syncDNLoading: ZohoIntegrationReducers.syncDNLoading,
  customFieldsProps: CFV2Reducers.cfV2DocDebitNote,
  syncTallyGRNLoading: ZohoIntegrationReducers.syncTallyGRNLoading,
  pushDebitNoteToBusyLoading: BusyIntegrationReducers.pushDebitNoteToBusyLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getDN: (tenantId, tenantSellerId, dnId, status, page, limit, searchKeyword, is_list) => dispatch(DNActions.getDN(tenantId, tenantSellerId, dnId, status, page, limit, searchKeyword, is_list)),
  getDNSuccess: (dn) => dispatch(DNActions.getDNSuccess(dn)),
  syncDN: (payload, callback) => dispatch(ZohoIntegrationActions.syncDN(payload, callback)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getDocCFV2Success: (cf) => dispatch(CFV2Actions.getDocCFV2Success(cf)),
  pushDebitNoteToBusy: (payload, callback) => dispatch(BusyIntegrationActions.pushDebitNoteToBusy(payload, callback)),
  syncTallyGRN: (payload, callback) => dispatch(TallyIntegrationActions.syncTallyGRN(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DebitNoteList));
